import { Fragment } from 'react'
import { FormFieldsEdit, FormFieldsView, WellUseFieldsEdit, WellUseFieldsView } from '../../../../types/form-types'
import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'

interface WellDetailsIdentifiersViewProps {
  isLoading: boolean
  fields: Partial<FormFieldsView> | Partial<FormFieldsEdit>
}

export default function WellDetailsIdentifiersView({ isLoading, fields }: WellDetailsIdentifiersViewProps) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Identifiers
      </Heading>
      <FormField isSkeleton={isLoading} labelId='councilWellNo' label='Council well number'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='councilWellNo' value={`${fields.councilWellNo ?? ''}`} />
      </FormField>

      <FormField isSkeleton={isLoading} label='Well region' labelId='wellRegionLabelId'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='wellRegionLabelId'
          value={`${fields.councilRegionName ?? ''}`}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='wellStatus' label='Status'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='wellStatus' value={`${fields.wellStatus ?? ''}`} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='wellName' label='Well name'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='wellName' value={`${fields.wellName ?? ''}`} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='wellType' label='Type'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='wellType' value={`${fields.wellType ?? ''}`} />
      </FormField>
      <FormField isSkeleton={isLoading} labelId='wellUse' label='Well use(s)'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='wellUse'>
          {Array.isArray(fields.wellUses)
            ? fields.wellUses.map((field: WellUseFieldsView | WellUseFieldsEdit, index) => {
                const separator = index > 0 ? <>{', '}</> : ''
                return (
                  <Fragment key={index}>
                    {separator}
                    {field.name}
                  </Fragment>
                )
              })
            : fields.wellUses}
        </ReadOnlyField>
      </FormField>
    </>
  )
}
